export const CACHE_KEYS = {
	clientSelection: 'CLIENT_SELECTION',
	containerSelection: 'CONTAINER_SELECTION',
	dailyTripTypes: 'DAILY_TRIP_TYPES',
	driverSelection: 'DRIVER_SELECTION',
	employeeRole: 'EMPLOYEE_ROLE',
	HelperSelection: 'HELPER_SELECTION',
	paymentTypeSelection: 'PAYMENT_TYPE_SELECTION',
	payrollDateSelection: 'PAYROLL_DATE_SELECTION',
    payrollTypeSelection: 'PAYROLL_TYPE_SELECTION',
	rightsResult: "USER_RIGHTS",
	salaryTypeSelection: 'SALARY_TYPE_SELECTION',
	shippingLineSelection: 'SHIPPINGLINE_SELECTION',
	tripRates: 'TRIP_RATES',
	tripSelection: 'TRIP_SELECTION',
	tripTypes: 'TRIP_TYPES',
	userSelection: 'USER_SELECTION',
	vehicleSelection: 'VEHICLE_SELECTION'
}


// WEBPACK FOOTER //
// ./src/app/contants/CACHE_KEYS.ts